// extracted by mini-css-extract-plugin
export default {"root":"CookieConsentBanner_root__DuP0U","alert":"CookieConsentBanner_alert__snO3e","button":"CookieConsentBanner_button__IJav2"};